import type { BlockAuthFormMode } from "#block-auth-form";

export function getBlockAuthFormHeaderTitle(mode: BlockAuthFormMode) {
  switch (mode) {
    case "reset": {
      return "Reset password";
    }
    case "signIn": {
      return "Sign in";
    }
    case "signUp": {
      return "Create an account";
    }
    case "twoFactor": {
      return "Two-factor authentication";
    }
    case "verifyEmail": {
      return "Verify email";
    }
  }
}
